<!--
* @description:
* @fileName pageEdit.vue
* @author hvv
* @date 2022/01/18 09:36:48
!-->
<template>
  <el-dialog v-model="dialogFormVisible" title="短信邀请" width="60%" @close="close">
    <el-form ref="formRef" :inline="true" label-width="140px" :model="form" :rules="rules">
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="form.phone" placeholder="多个手机号，请使用英文,（逗号）隔开" rows="10" type="textarea" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </template>
  </el-dialog>
</template>
<script>
  import { defineComponent, getCurrentInstance, reactive, toRefs } from 'vue'
  import { smsInviteUserByBatch } from '@/api/hostApply'

  export default defineComponent({
    name: 'BatchInviteSms',
    emits: ['fetch-data'],
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()

      const state = reactive({
        rules: {
          phone: [
            {
              required: true,
              trigger: 'blur',
              message: '请输入邀请用户的手机号',
            },
          ],
        },
        title: '',
        dialogFormVisible: false,
        formRef: null,
        form: {
          phone: '',
          code: '',
        },
      })

      const showEdit = async (row) => {
        state.form.code = row.invitationCode
        state.dialogFormVisible = true
      }

      const close = () => {
        state['formRef'].resetFields()
        state.form.phone = ''
        state.dialogFormVisible = false
      }

      const save = () => {
        state['formRef'].validate(async (valid) => {
          if (valid) {
            await smsInviteUserByBatch({ phones: state.form.phone })
            proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            emit('fetch-data')
            close()
          }
        })
      }

      return {
        ...toRefs(state),
        showEdit,
        close,
        save,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }
  .demo-drawer__footer {
    position: fixed;
    right: 20px;
    bottom: 10px;
  }
</style>
